import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import blogData from '../data/blogArticles.json';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const handleBackToBlog = () => {
    // Forcer la navigation vers la racine avec hash pour déclencher ScrollToHash
    navigate('/#blog', { replace: false });
  };
  
  const article = blogData.articles.find(article => article.slug === slug);

  useEffect(() => {
    if (!article) {
      navigate('/');
      return;
    }
    // Update page title
    document.title = `${article.title} - Bravo Energy`;
    // Scroll to top
    window.scrollTo(0, 0);
  }, [article, navigate]);

  if (!article) {
    return null;
  }

  const formatDate = (dateString) => {
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      locale: 'fr-FR'
    };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  return (
    <div className="blog-post-page">
      {/* Navigation */}
      <section className="blog-post-nav">
        <div className="container">
          <button onClick={handleBackToBlog} className="blog-back-btn btn btn-secondary btn-sm btn-ripple">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"/>
            </svg>
            Retour au blog
          </button>
        </div>
      </section>

      {/* Article Header */}
      <section className="blog-post-header">
        <div className="container">
          <div className="blog-post-meta">
            <span className="blog-post-category">{article.category}</span>
            <div className="blog-post-date-time">
              <span>{formatDate(article.date)}</span>
              <span>•</span>
              <span>{article.readTime}</span>
            </div>
          </div>
          
          <h1 className="blog-post-title">{article.title}</h1>
          
          <div className="blog-post-author">
            <div className="author-avatar">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
              </svg>
            </div>
            <span>{article.author}</span>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="blog-post-image">
        <div className="container">
          <img
            src={article.image}
            alt={article.title}
            className="featured-image"
          />
        </div>
      </section>

      {/* Article Content */}
      <section className="blog-post-content">
        <div className="container">
          <div className="content-wrapper">
            
            {/* Summary */}
            <div className="article-summary">
              <h3>En résumé</h3>
              <p>{article.summary}</p>
            </div>

            {/* Article Text */}
            <div className="article-text">
              {article.content.split('\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {/* Keywords */}
            <div className="article-keywords">
              <h4>Mots-clés</h4>
              <div className="keywords-list">
                {article.keywords.map((keyword, index) => (
                  <span key={index} className="keyword-tag">
                    {keyword}
                  </span>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="blog-post-cta">
        <div className="container">
          <div className="cta-content">
            <h3>Besoin d'un conseil personnalisé ?</h3>
            <p>Contactez nos experts Bravo Energy pour votre projet énergétique à Bruxelles.</p>
            <div className="cta-buttons">
              <a href="#contact" className="btn btn-primary btn-lg">
                Demander un conseil gratuit
              </a>
              <button onClick={handleBackToBlog} className="btn btn-secondary btn-lg">
                Voir plus d'articles
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPost;

